// Single place where pdf.js is configured for react-pdf. Worker, CMaps and
// standard fonts are served locally from public/pdfjs/ (copied from the
// pdfjs-dist react-pdf uses by scripts/copy-pdfjs-assets.js on prestart /
// prebuild), so PDFs render without internet access.
import { pdfjs } from 'react-pdf'

const PDFJS_BASE = `${process.env.PUBLIC_URL || ''}/pdfjs`

pdfjs.GlobalWorkerOptions.workerSrc = `${PDFJS_BASE}/pdf.worker.min.mjs`

// Pass as <Document options={PDF_DOCUMENT_OPTIONS}>. Module-level constant:
// react-pdf reloads the document whenever the options object changes identity.
export const PDF_DOCUMENT_OPTIONS = {
  cMapUrl: `${PDFJS_BASE}/cmaps/`,
  cMapPacked: true,
  standardFontDataUrl: `${PDFJS_BASE}/standard_fonts/`,
}
